<script setup lang="ts">
import { computed } from 'vue';
import { ElIcon } from 'element-plus';
import { propTypes } from '@/utils/propTypes';
import { useDesign } from '@/hooks/web/useDesign';
import { pxToRem } from '@/utils/commonFun';

const { getPrefixCls } = useDesign();

const prefixCls = getPrefixCls('icon');

const props = defineProps({
    // icon name
    icon: propTypes.string,
    // icon color
    color: propTypes.string,
    // icon size
    size: propTypes.number.def(16),
});
const { size } = props;
const symbolId = computed(() => {
    return `#icon-${props.icon.split('svg-icon:')[1]}`;
});
</script>

<template>
    <ElIcon :class="prefixCls" :color="color" :style="{ fontSize: pxToRem(size) }" class="cursor-pointer dir-icon">
        <svg aria-hidden="true">
            <defs>
                <slot name="hover" />
                <slot name="click" />
            </defs>

            <use :xlink:href="symbolId" :style="{ fill: color }" />
        </svg>
    </ElIcon>
</template>
<style scoped>
/* .dir-icon {
    font-size: v-bind(size);
} */
</style>
